<ul>
  @if (refBatId.egid) {
  <li>Egid : {{ refBatId.egid }}</li>
  } @if (refBatId.idIcareplus) {
  <li>Icare+ : {{ refBatId.idIcareplus }}</li>
  }
</ul>
<hr />
